import { createEvent } from 'effector';
import { type Filters } from './types';

export const resetFilters = createEvent();
export const setFilters = createEvent<Partial<Filters>>();
